import { render } from "./KickOffSection.vue?vue&type=template&id=5b9c8a0a&scoped=true"
import script from "./KickOffSection.vue?vue&type=script&lang=js"
export * from "./KickOffSection.vue?vue&type=script&lang=js"

import "./KickOffSection.vue?vue&type=style&index=0&id=5b9c8a0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9c8a0a"]])

export default __exports__